import { useState, useEffect } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

const SHORTCUTS = [
  { keys: ['⌘', 'K'], label: 'Command Palette' },
  { keys: ['⌘', '?'], label: 'Keyboard Shortcuts' },
  { keys: ['⌘', '.'], label: 'Toggle Focus Mode' },
  { keys: ['⌘', 'B'], label: 'Toggle Sidebar' },
  { keys: ['⌘', 'D'], label: 'Toggle Dark Mode' },
  { keys: ['⌘', 'E'], label: 'Evaluate (Decision Engine)' },
];

export function KeyboardShortcutsDialog({ open, onOpenChange }: { open: boolean; onOpenChange: (o: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-[15px]">Keyboard Shortcuts</DialogTitle>
        </DialogHeader>
        <div className="space-y-1">
          {SHORTCUTS.map(s => (
            <div key={s.label} className="flex items-center justify-between py-2 px-1 border-b border-border/30 last:border-0">
              <span className="text-[12px] text-muted-foreground">{s.label}</span>
              <div className="flex items-center gap-0.5">
                {s.keys.map((k, i) => (
                  <kbd key={i} className="inline-flex items-center justify-center h-6 min-w-[24px] px-1.5 rounded bg-muted border border-border text-[10px] font-mono text-foreground">
                    {k}
                  </kbd>
                ))}
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
